import { render } from "./SearchModal.vue?vue&type=template&id=53158ffd"
import script from "./SearchModal.vue?vue&type=script&lang=ts"
export * from "./SearchModal.vue?vue&type=script&lang=ts"
script.render = render

export default script